module.exports = __webpack_public_path__ + "img/group-3@3x.9c4a12cf.png";